import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import MomentTimezone from "moment-timezone";
import ProfileImage from "components/profileImage";
import AdminNotesServiceOrder from "../../pages/Orders/AdminNotes.jsx";
import { getStatusByBgClass } from "components/Common/GetStatus";
import ServiceOrderHistory from "pages/Orders-v2/OrderHistory";
import RescheduleDoctorOrder from "./RescheduleOrder.js";
import CancelDoctorOrder from "./CancelDoctorOrder.jsx";
const ConsultationOrderDetailsPage = ({
  activeOrder,
  handleActiveOrder,
  getAllOrdersList,
}) => {
  const [modal, setModal] = useState(false);
  console.log(activeOrder, "actOrderrrr");
  const [order, setOrder] = useState({});
  useEffect(() => {
    if (activeOrder && activeOrder) {
      const currentOrder = activeOrder;
      currentOrder.createdAt = MomentTimezone.tz(
        currentOrder.createdDate,
        currentOrder?.timeZone || "Asia/Kolkata"
      ).format("DD-MMMM-YYYY @ h:mm a");
      currentOrder.appointmentDate = MomentTimezone.tz(
        currentOrder.appointmentDate,
        currentOrder?.timeZone || "Asia/Kolkata"
      ).format("DD-MMMM-YYYY");
      setOrder(currentOrder);
    }
  }, [activeOrder]);

  const RenderPaymentDone = order => {
    return (
      <div className="d-flex justify-content-between border border-2 rounded p-2 ">
        <div className="d-flex">
          <i className="bx bx-md bx-check-circle text-success p-2"></i>
          {order?.status == "Paid" ? (
            <h6 className="p-2 mt-2">Payment is done</h6>
          ) : (
            <h6 className="p-2 mt-2">Payment is not yet done.</h6>
          )}
        </div>
      </div>
    );
  };
  const [loading, setLoading] = useState(false);
  const toggleReschedule = () => {
    setModal(!modal);
  };
  return (
    <>
      <div className="Order_details_card">
        {activeOrder ? (
          <div>
            {" "}
            <Card className="mb-0">
              <CardBody className="border-3 border-bottom pb-1">
                <Row>
                  <Col md="6" className="">
                    <div className="">
                      <div className="d-flex justify-content-between mb-4 align-items-center">
                        <div className="">
                          <h6 className="font-size-18 fw-bold mb-0">
                            Order ID #{order?.orderId}
                          </h6>
                        </div>
                        <div className="">
                          <CancelDoctorOrder
                            activeOrder={order}
                            getOrdersList={getAllOrdersList}
                            getOrderById={handleActiveOrder}
                            Status={order?.status}
                          />
                        </div>
                      </div>
                      <h6 className="fw-bold">
                        Created On :
                        <span className="fw-bold"> {order?.createdAt}</span>
                      </h6>
                    </div>
                  </Col>
                  <Col md="6" className="border-start border-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <p className="mb-2">Appointment Date & Time :</p>
                        <h6 className="">
                          {order?.appointmentDate} @{" "}
                          {order?.appointmentTime
                            ? order?.appointmentTime
                            : order?.timeOfTheDay}
                        </h6>
                      </div>
                      <div>
                        <button
                          className={
                            "btn btn-sm font-size-12 text-white " +
                            getStatusByBgClass(" bg", order?.status)
                          }
                        >
                          {order?.status}
                        </button>
                      </div>
                    </div>
                    {/* )} */}
                  </Col>
                </Row>
              </CardBody>
              <CardBody className=" border-3 border-bottom ">
                <Row>
                  <Col className="">
                    <div>
                      <div className="bg-light p-1 mb-3">
                        <p className="mb-0">User Details</p>
                      </div>
                      <div className="me-4 d-flex flex-wrap">
                        <ProfileImage
                          image={
                            order?.user?.userImage === "undefined"
                              ? noImage
                              : order?.user?.userImage
                          }
                          height="70"
                          width={70}
                          classNames="me-2 border"
                        />
                        <div>
                          <div className="d-flex align-items-center ">
                            <h6 className="mt-1 ">
                              {order?.user?.firstname
                                ? order.user?.firstname
                                : "-"}{" "}
                              {order?.user?.lastname
                                ? order.user?.lastname
                                : "-"}
                            </h6>
                          </div>

                          <div className="d-flex align-items-center ">
                            <div>
                              <h6>Age : </h6>
                            </div>
                            <h6 className="ms-1">
                              {order?.user?.age ? order?.user?.age : "-"}
                            </h6>
                          </div>
                          <div className="d-flex align-items-center ">
                            <div>
                              <h6>Gender : </h6>
                            </div>
                            <h6 className="ms-1">
                              {order?.user?.gender ? order?.user?.gender : "-"}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  {order?.userInfo && (
                    <Col md="6" className="">
                      <div>
                        <div className="bg-light p-1 mb-3">
                          <p className="mb-0">Patient info</p>
                        </div>
                        <div className="me-4 d-flex flex-wrap">
                          <ProfileImage
                            image={
                              order?.userInfo?.userImage === "undefined"
                                ? noImage
                                : order?.userInfo?.userImage
                            }
                            height="70"
                            width={70}
                            classNames="me-2 border"
                          />
                          <div>
                            <div className="d-flex align-items-center ">
                              <h6 className="mt-1 ">
                                {order?.userInfo?.name
                                  ? order.userInfo?.name
                                  : "-"}
                              </h6>
                            </div>

                            <div className="d-flex align-items-center ">
                              <div>
                                <h6>Age : </h6>
                              </div>
                              <h6 className="ms-1">
                                {order?.userInfo?.age
                                  ? order?.userInfo?.age
                                  : "-"}
                              </h6>
                            </div>
                            <div className="d-flex align-items-center ">
                              <div>
                                <h6>Gender : </h6>
                              </div>
                              <h6 className="ms-1">
                                {order?.userInfo?.gender
                                  ? order?.userInfo?.gender
                                  : "-"}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </CardBody>
              <CardBody className="p-3  border-3 border-bottom ">
                <Row>
                  <Col className="">
                    <div>
                      <div className="bg-light p-1">
                        <p className="mb-0">Doctor Details</p>
                      </div>
                      <div className="d-flex flex-wrap align-items-center mt-3">
                        <ProfileImage
                          image={
                            order?.doctor?.profileImage === "undefined"
                              ? noImage
                              : order?.doctor?.profileImage
                          }
                          height="100"
                          width={100}
                          classNames="me-2"
                        />
                        <div className="ms-3">
                          <h6 className="fw-bold">
                            {order?.doctor?.fullName}{" "}
                            {/* {doctor?.shortName} */}
                          </h6>
                          <div className="mt-1">
                            <span className="">
                              Since : {order?.doctor?.practicingSince}
                            </span>
                          </div>
                          <div className="mt-1">
                            <span>
                              Experience : {order?.doctor?.experience}
                            </span>
                          </div>
                          <div className="mt-1">
                            <span>Languages : </span>
                            {order?.doctor?.languages?.map((ele, ind) => (
                              <span key={ind}>
                                {ele}{" "}
                                {ind < order?.doctor?.languages?.length - 1
                                  ? ", "
                                  : ""}
                              </span>
                            ))}
                          </div>
                          <div className="mt-1">
                            <span>Specialization : </span>
                            {order?.doctor?.specialization?.map((ele, ind) => (
                              <span key={ind}>
                                {ele}{" "}
                                {ind < order?.doctor?.specialization?.length - 1
                                  ? ", "
                                  : ""}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  {order?.status === "Confirmed" ? (
                    <Col md={6} className="border-start border-3">
                      <div>
                        <div className="bg-light p-1">
                          <p className="mb-0">Reshedule Order</p>
                        </div>
                        <button
                          className="btn btn-sm px-3 py-1 font-size-12 btn-primary-red mt-3"
                          onClick={() => {
                            toggleReschedule();
                          }}
                        >
                          Reschedule Order
                        </button>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </CardBody>
              <CardBody className="p-3">
                <Row>
                  <div>
                    <div className="bg-light p-1">
                      <p className="mb-0">Patient Details</p>
                    </div>
                    <Col md={12} className=" pt-4 px-0 user_detail">
                      <Row className="mx-3">
                        <Col md={4} className="">
                          <p className="ps-0">
                            <p className="mb-1 fw-bold">Parent Category </p>{" "}
                            <p className="text-muted">
                              {order?.parentCategory?.name}
                            </p>
                          </p>
                        </Col>
                        <Col md={4} className="">
                          <p className="ps-0">
                            <p className="mb-1 fw-bold">Problem</p>{" "}
                            <p className="text-muted">
                              {order?.category?.title}{" "}
                            </p>
                          </p>
                        </Col>
                        <Col md={4} className="">
                          <p className="fw-bold mb-1">Problem Duration</p>
                          <p className="text-muted">
                            {order?.problemDuration
                              ? order?.problemDuration
                              : "_"}
                          </p>
                        </Col>

                        {order?.patientDetails &&
                          Object.entries(order.patientDetails).map(
                            ([key, values]) =>
                              values && values.length > 0 ? ( // ✅ only render if non-empty
                                <Col md={4} key={key} className="mb-3">
                                  <p className="fw-bold mb-1">
                                    {key
                                      .replace(/([A-Z])/g, " $1")
                                      .replace(/^./, str => str.toUpperCase())}
                                  </p>
                                  {values.map((item, index) => (
                                    <p key={index} className="text-muted mb-0">
                                      {item}
                                    </p>
                                  ))}
                                </Col>
                              ) : null
                          )}
                        <Col md={12} className="mt-3">
                          <p className="fw-bold mb-1">symptoms</p>
                          <p className="text-muted">
                            {order?.symptoms ? order?.symptoms : "_"}
                          </p>
                        </Col>
                        {order?.userReferenceImages?.length > 0 ? (
                          <>
                            <p className="fw-bold mb-3">
                              User Reference Images
                            </p>
                            <div className="d-flex align-items-center flex-wrap">
                              {order?.userReferenceImages?.map((url, index) => (
                                <div className="me-3" key={index}>
                                  <img
                                    src={url}
                                    alt={`Uploaded ${index + 1}`}
                                    className="img-fluid rounded shadow"
                                    width={"100px"}
                                    height={"100px"}
                                    style={{ height: "100px" }}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                    </Col>
                  </div>
                  <div className="mt-3">
                    <div className="bg-light p-1">
                      <p className="mb-0">Prescription Details</p>
                    </div>
                    <Col md={12} className=" pt-4 px-0 user_detail">
                      <Row className="mx-3">
                        {order?.prescription &&
                          Object.entries(order?.prescription).map(
                            ([key, value]) => {
                              // Skip empty arrays
                              if (Array.isArray(value) && value.length === 0)
                                return null;

                              return (
                                <Col md={6} key={key} className="mb-3">
                                  <p className="fw-bold mb-1">
                                    {key
                                      .replace(/([A-Z])/g, " $1")
                                      .replace(/^./, str => str.toUpperCase())}
                                  </p>

                                  {/* Case 1: Array of strings */}
                                  {Array.isArray(value) &&
                                    typeof value[0] === "string" && (
                                      <>
                                        {value.map((item, i) => (
                                          <p
                                            className="text-muted mb-0"
                                            key={i}
                                          >
                                            {item}
                                          </p>
                                        ))}
                                      </>
                                    )}

                                  {/* Case 2: Array of objects (e.g., medicines) */}
                                  {Array.isArray(value) &&
                                    typeof value[0] === "object" && (
                                      <>
                                        {value.map((obj, i) => (
                                          <div key={i} className="mb-2 ps-2">
                                            {Object.entries(obj)
                                              .filter(([k]) => k !== "_id")
                                              .map(([k, v]) => (
                                                <p
                                                  className="text-muted mb-0"
                                                  key={k}
                                                >
                                                  <strong>
                                                    {k[0].toUpperCase() +
                                                      k.slice(1)}
                                                    :
                                                  </strong>{" "}
                                                  {v}
                                                </p>
                                              ))}
                                          </div>
                                        ))}
                                      </>
                                    )}

                                  {/* Case 3: Primitive values */}
                                  {!Array.isArray(value) && (
                                    <p className="text-muted mb-0">
                                      {typeof value === "boolean"
                                        ? value
                                          ? "Yes"
                                          : "No"
                                        : value}
                                    </p>
                                  )}
                                </Col>
                              );
                            }
                          )}
                      </Row>
                    </Col>
                  </div>
                </Row>
              </CardBody>
            </Card>
            {order?.status != "Cancelled" ? (
              <Card className="mb-0 mt-2">
                {" "}
                <CardBody className="p-2"> {RenderPaymentDone(order)}</CardBody>
              </Card>
            ) : (
              ""
            )}
            <Card className="mt-2">
              <CardBody className="">
                {" "}
                <div className="bg-light p-1">
                  <p className="mb-0">Payment Details</p>
                </div>
                <div className="d-flex justify-content-start mb-0 mt-4 px-0">
                  <div className="me-5">
                    <p className="">Payment Method </p>

                    <p className="">Payment Status</p>
                    <p className="">
                      <b>Total Amount</b>
                    </p>
                    <p className="">Upfront Amount</p>
                  </div>

                  <div className="text-end ms-5">
                    <p className="">
                      {order?.payment?.paymentBreakup?.paymentMethod}{" "}
                    </p>

                    <p className="">{order?.payment?.paymentStatus}</p>

                    <p className="">
                      <b>₹ {order?.payment?.totalAmount?.toFixed(2)}</b>
                    </p>
                    <p className="">
                      ₹ {order?.payment?.upfrontAmount?.toFixed(2)}
                    </p>
                  </div>
                </div>
              </CardBody>
            </Card>
            <ServiceOrderHistory
              OrderHistory={order?.orderHistory}
              userLocation={order?.address}
            />
            <div className="">
              <AdminNotesServiceOrder activeOrder={order} />
            </div>
          </div>
        ) : (
          <Card className="p-3 pt-0 empty_order">
            <CardBody className="border-3">
              <div className="text-center">
                <i className="mdi mdi-arrow-left-circle" id="nullCatList"></i>
              </div>
              <p className="text-center">Please Select Order</p>
            </CardBody>
          </Card>
        )}
        <RescheduleDoctorOrder
          toggle={toggleReschedule}
          modal={modal}
          activeOrder={activeOrder}
          loading={loading}
          getAllOrdersList={getAllOrdersList}
          reload={handleActiveOrder}
        />
      </div>
    </>
  );
};

export default ConsultationOrderDetailsPage;
